<template>
  <div :class="_.card">
    <div v-if="title" :class="_.title">{{ title }}</div>
    <slot />
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      title: {
        type: String,
        default: '',
      },
    },
  })
</script>

<style lang="scss" module>
  .card {
    position: relative;
    background: #ffffff;
    border-radius: 8px;
    padding: 12px;
    margin: 10px 12px;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #222222;
      margin-bottom: 12px;
    }
  }
</style>
